import { Link } from "react-router-dom";
import { MenuOutlined } from "@ant-design/icons";
import { useState } from "react";
import { useSelector } from "react-redux";
import TooltipText from "../TooltipText";
import "./Sidebar.css";


const Sidebar = () => {
  const { user } = useSelector((state) => state.authentication);

  const [show, setShow] = useState(false);
  const [hover, setHover] = useState(false);

  const list = [
    {
      title: "Búsqueda de Contribuyentes",
      path: "abogado-externo",
      show: true,
      text: "Búsqueda de Contribuyentes"
    },
    {
      title: "Mesa de entradas extrajudicial",
      path: "mesa-extrajudicial",
      show: true,
      text: "Mesa de entradas extrajudicial"
    },
    {
      title: "Mesa de entradas judicial",
      path: "mesa-judicial",
      show: true,
      text: "Mesa de entradas judicial"
    },
    // {
    //   title: "Contribuyentes",
    //   path: "contribuyentes",
    //   show: true,
    //   text: "Permite consultar ( no modificar) los datos sobre el contribuyente que tiene RAFAM."
    // },
    // {
    //   title: "Novedades",
    //   path: "novedades",
    //   show: true,
    //   text: "Permite visualizar los datos tanto del inmueble como del contribuyente distintos a los de RAFAM."
    // },
    // {
    //   title: "Inmuebles",
    //   path: "inmuebles",
    //   show: true,
    //   text: "Es una ventana de consulta, permite una búsqueda partiendo del dato de un inmueble."
    // },
    // {
    //   title: "Comercios",
    //   path: "comercios",
    //   show: true,
    //   text: "Es una ventana de consulta, permite buscar comercios partiendo del dato de un inmueble."
    // },
    {
      title: "Abogados",
      path: "mis-datos",
      show: true,
      text: "Datos del abogado externo."
    },
    {
      title: "Abogados",
      path: "abogados",
      show: (user.rol === "admin" || user.abogado === "A00"),
      text: "Es un listado de los abogados que actualmente trabajan como apoderados externos."
    },
    {
      title: "Comunicaciones",
      path: "comunicaciones",
      show: true,
      text: "Comunicaciones"
    },
    {
      title: "Scoring abogados",
      path: "scoring-abogados",
      show: user.dni === "28978423" || user.dni === "40763199",
      text: "Scoring abogados externos."
    },
    // {
    //   title: "Condiciones Legales",
    //   path: "condiciones",
    //   show: (user.rol === "admin" || user.abogado === "A00"),
    //   text: "Convenios firmados entre apoderados y municipio y sus respectivos poderes."
    // },
    // {
    //   title: "Gestión Legal",
    //   path: "gestion",
    //   show: true,
    //   text: "Ventana en la cual el apoderado carga los movimientos de la causa."
    // },
    {
      title: "Convenios",
      path: "convenios",
      show: user.rol === "admin",
      text: "Permite generar convenio de pago de honorarios y reconocimiento de deudas."
    },
    // {
    //   title: "Planes de Pago",
    //   path: "planes-de-pago",
    //   show: true,
    //   text: "Permite ver el estado actual de los planes de pago."
    // },
    // {
    //   title: "Registros",
    //   path: "registros",
    //   show: true,
    //   text: "Ver Registros."
    // },
    {
      title: "Configuración",
      path: "configuracion",
      show: (user.rol === "admin" || user.abogado === "A00"),
      text: "Ver Configuración."
    },
    // {
    //   title: "Historial",
    //   path: "historial",
    //   show: (user.rol === "admin" || user.abogado === "A00"),
    //   text: "Ver Historial de acciones."
    // },
  ];

  return (
    <div
      className={`sidebar ${(show || hover) ? "show-sidebar" : "hidden-sidebar"}`}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <div
        className={`menu-icon ${show ? "show-menu" : "hidden-menu"}`}
        onClick={() => setShow(!show)}
      >
        <MenuOutlined />
      </div>
      {/* {(show || hover) ? ( */}
      <div className={`sections ${(show || hover) ? "show-sections" : "hidden-sections"}`}>
        {list.map((e) => {
          return e.show ? (
            <TooltipText
              key={e.path}
              placement={"right"}
              text={e.text}
            >
              <div className="section">
                <Link className="nav-link" to={e.path}>{e.title}</Link>
              </div>
            </TooltipText>
          ) : null;
        })}

      </div>
      {/* ) : null} */}
    </div>
  );
};

export default Sidebar;